import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { HttpCacheService } from './http-cache.service';

@Injectable({
    providedIn: 'root',
})
export class LogoutService {
    // Prefixes for keys to preserve in localStorage during logout
    private readonly PRESERVED_KEY_PREFIXES = [
        'qwyk_custom_fields_state_',
    ];

    constructor(
        private localStorageService: LocalStorageService,
        private httpCacheService: HttpCacheService
    ) {}

    /**
     * Logs out the user by clearing all user-specific data from storage.
     * It preserves essential keys while wiping session-related information.
     */
    public logout(): void {
        // Clear all session storage
        sessionStorage.clear();

        // Clear memory cache
        this.httpCacheService.invalidateAll();

        // Clear localStorage, preserving specific keys
        this.clearLocalStorageWithWhitelist();
    }

    /**
     * Clears localStorage, except for keys that match preserved prefixes.
     */
    private clearLocalStorageWithWhitelist(): void {
        if (!this.localStorageService.available) {
            return;
        }

        const keysToRemove: string[] = [];
        for (let i = 0; i < window.localStorage.length; i++) {
            const key = window.localStorage.key(i);
            if (key) {
                // Check if the key starts with any of the preserved prefixes
                const shouldPreserve = this.PRESERVED_KEY_PREFIXES.some(prefix =>
                    key.startsWith(prefix)
                );

                if (!shouldPreserve) {
                    keysToRemove.push(key);
                }
            }
        }

        keysToRemove.forEach(key => {
            this.localStorageService.remove(key);
        });
    }
}
